export const borders = [0, "1px solid", "2px solid"]
